import React, { useEffect, useState } from 'react';
import { TopToolbar, ReferenceInput, AutocompleteInput, SearchInput, SelectInput, SelectColumnsButton, Pagination, useStore, useListContext } from 'react-admin';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import GetAppIcon from '@mui/icons-material/GetApp';

import List, { DefaultListActions } from '../../common/views/List';
import IconButton from '../../common/buttons/IconButton';
import LeadRow from './LeadRow';
import LeadKanban from './LeadKanban';

import { API_URL } from '../../../services/settings';
import { leadStatusChoices, leadSourceChoices, leadDirectionChoices } from '../constants';;

const buttonGroupSx = { marginBottom: '-2px' };
const inactiveButtonSx = { color: (theme) => theme.palette.action.disabled };

const userOptionText = choice => choice && choice.fullname ? choice.fullname : '';


const ViewButton = ({ viewKanban, setViewKanban }) => {
    const handleClickList = () => {
        setViewKanban(false);
    };

    const handleClickGrid = () => {
        setViewKanban(true);
    };

    return (
        <ButtonGroup size="small" variant="text" sx={buttonGroupSx}>
            <Button onClick={handleClickGrid} sx={viewKanban ? {} : inactiveButtonSx}><ViewKanbanIcon /></Button>
            <Button onClick={handleClickList} sx={viewKanban ? inactiveButtonSx : {}}><ViewHeadlineIcon /></Button>
        </ButtonGroup>
    );
};

const LeadPagination = ({ viewKanban, ...props }) => {
    const { perPage, setPage, setPerPage } = useListContext();
    const [oldPerPage] = useState(perPage);

    useEffect(() => {
        if (viewKanban) {
            setPerPage(200);
            setPage(1);
        }
        else {
            setPerPage(oldPerPage);
            setPage(1);
        }
    }, [viewKanban]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Pagination rowsPerPageOptions={[25, 50, 100, 200]} {...props} />
    );
};

const LeadListActions = (props) => (
    <TopToolbar sx={{ alignItems: 'center' }}>
        <DefaultListActions>
            {!props.viewKanban && <SelectColumnsButton />}
            <ViewButton {...props} />
            <IconButton
                icon={<GetAppIcon />}
                component="a"
                href={`${API_URL}/leads/export.xls`}
                target="_blank"
                rel="noopener noreferrer"
            >
                Export
            </IconButton>
        </DefaultListActions>
    </TopToolbar>
);

const leadFilters = [
    <SearchInput source="q" alwaysOn />,
    <SelectInput source="active" choices={[
        { id: 'true', name: 'Active Leads' },
        { id: 'false', name: 'Lost/Unqualified' },
    ]} alwaysOn sx={{ m: 0 }} />,
    <SelectInput source="status" choices={leadStatusChoices} sx={{ m: 0 }} />,
    <SelectInput source="source" choices={leadSourceChoices} sx={{ m: 0 }} />,
    <SelectInput source="direction" choices={leadDirectionChoices} sx={{ m: 0 }} />,
    <ReferenceInput source="campaign_id" reference="campaigns" label="Campaign" allowEmpty>
        <AutocompleteInput />
    </ReferenceInput>,
    <ReferenceInput label="Assigned To" source="assigned_to_id" reference="users" sort={{ field: 'id', order: 'ASC' }} allowEmpty>
        <AutocompleteInput optionText={userOptionText} />
    </ReferenceInput>,
    <SelectInput source="archived" label="Archived" sx={{ m: 0 }} choices={[
        { id: 'false', name: 'Active' },
        { id: 'true', name: 'Archived' },
    ]} />,
];

const LeadList = props => {
    const [viewKanban, setViewKanban] = useStore('leads.list.viewKanban', false);

    let customProps = {};
    if (viewKanban) {
        customProps = { component: 'div' };
    }

    return (
        <List
            filters={leadFilters}
            actions={<LeadListActions viewKanban={viewKanban} setViewKanban={setViewKanban} />}
            exporter={false}
            filterDefaultValues={{ archived: 'false', active: 'true' }}

            {...props}
            {...customProps}
            pagination={<LeadPagination viewKanban={viewKanban} />}
        >
            {viewKanban ? (
                <LeadKanban />
            ) : (
                <LeadRow />
            )}
        </List>
    );
};

export default LeadList;